export const ConfigDocumentosRecibidos = {
	barraBusqueda: {
		criterios: ["Razon Social", "Rut Proveedor", "Folio", "Monto Total"],
		criteriosKeys: ["nombreProveedor", "rutProveedor", "folio", "montoTotal"],
		criterioPrincipal: "Razon Social",
		filiales: [] as any[],
		datePicker: true,
		datePickerVenc: true,
		datePickerRecepcion: true,
		nombreCampoDatePicker: "Fecha Emisión (Desde - Hasta)",
	},
	table: {
		title: "Documentos Recibidos",
		add: "Carga Documento",
		options: [
			{
				name: "Importar",
				active: true,
				class: "ft-upload",
			},
			{
				name: "Exportar",
				active: true,
				class: "ft-download",
			},
			{
				name: "Solicitar Soporte",
				active: true,
				class: "ft-shuffle",
			},
		],
	},
};
